// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchInput-module--container--2OcPT","search":"SearchInput-module--search--_A-bi"};